
import { Event } from "@/types/event";

export interface EventImageWithCaption {
  image_id: string;
  image_url: string;
  is_primary: boolean;
  display_order: number;
  caption?: string;
  is_guest_avatar?: boolean;
}

/**
 * Merges event images with guest avatar images to create a complete carousel
 */
export function mergeEventAndGuestImages(
  event: Event
): EventImageWithCaption[] {
  // Initialize with event images
  const eventImages: EventImageWithCaption[] = 
    event.event_images?.map(img => ({
      ...img,
      is_guest_avatar: false
    })) || 
    event.additional_images?.map(img => ({
      ...img,
      is_guest_avatar: false
    })) || 
    [];
    
  // If there's a main event image and it's not already in the images array
  if (event.image_url && !eventImages.some(img => img.image_url === event.image_url)) {
    eventImages.push({
      image_id: 'main-event-image',
      image_url: event.image_url,
      is_primary: true,
      display_order: -1, // Make sure it appears first
      is_guest_avatar: false
    });
  }
  
  // Get accepted attendees with guest avatars
  const attendeesWithAvatars = (event.attendees || [])
    .filter(attendee => 
      (attendee.rsvp_status === 'accepted' || attendee.rsvp_status === 'yes') && 
      (attendee.guest_avatar_url || attendee.avatar_url)
    );
  
  // Add guest avatars with captions
  const guestImages: EventImageWithCaption[] = attendeesWithAvatars.map((attendee, index) => ({
    image_id: attendee.user_id || attendee.invite_id || `guest-${index}`,
    image_url: attendee.guest_avatar_url || attendee.avatar_url || '',
    is_primary: false,
    display_order: 100 + index, // Display after event images
    caption: attendee.isHost ? `${attendee.full_name} (Host)` : attendee.full_name,
    is_guest_avatar: true
  }));
  
  // Combine and sort
  const allImages = [...eventImages, ...guestImages]
    .sort((a, b) => a.display_order - b.display_order);
    
  return allImages;
}
